import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: 'app-notification-card',
    templateUrl: './notification-card.component.html',
    styleUrls: ['./notification-card.component.css'],
    standalone: false
})
export class NotificationCardComponent {
    @Input() label: string = '';
    @Input() message: string = '';
    @Input() type: 'success' | 'error' | 'warning' | 'info' = 'info';
    @Input() closable = true;
    @Input() showIcon = true;
    @Input() color: string = '';

    @Output() close = new EventEmitter<void>();

    show: boolean = true;

    closeNotification() {
        this.show = false;
        this.close.emit();
    }
}
